export default "__VITE_ASSET__BPwmAZ8M__"